//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const GetStoreCity = () =>
  request({
    url: ApiURL.Query.GetStoreCity,
    method: RequestType.GET,
  }); 
  const GetStoreCounty = (data:any) =>
  request({
    url: ApiURL.Query.GetStoreCounty+"/"+data,
    method: RequestType.GET,  
  }); 
  const GetStoreStock = (data:any) =>
  request({
    url: ApiURL.Query.GetStoreStock,
    method: RequestType.POST,  
    data:data
  }); 

  const GetComponentInformationBySpecialCode = (data: { specialCode: string }) =>
    request({
      url: ApiURL.Query.GetComponentInformationBySpecialCode,
      method: RequestType.POST,
      data,
    });

  const GetStyleMeasurementByPlmCode = (data: { PlmCode: string }) =>
    request({
      url: ApiURL.Query.GetStyleMeasurementByPlmCode,
      method: RequestType.POST,
      data,
    });


const ProductDetailServiceQuery = {
  GetStoreCity,
  GetStoreCounty,
  GetStoreStock,
  GetComponentInformationBySpecialCode,
  GetStyleMeasurementByPlmCode,
};

export default ProductDetailServiceQuery;
